import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { useBreadcrumbs } from './useBreadcrumbs';
import { Breadcrumb } from './BreadcrumbsContext';
import styles from './breadcrumbs.module.scss';

interface IBreadcrumbsProps {
  title?: string;
}

export default function Breadcrumbs({ title }: IBreadcrumbsProps) {
  const { breadcrumbs, breadcrumbsContainerRef } = useBreadcrumbs();

  const renderBreadcrumbItem = useCallback((el: Breadcrumb, isLast: boolean = false) => {
    if (el.customBreadcrumbItem) {
      return el.customBreadcrumbItem;
    }

    if (isLast) {
      return <>{el.title}</>;
    }

    return (
      <Link to={getParameterizedLink(el.path)}>{el.title}</Link>
    );
  }, []);

  return (
    <>
      <div
        className={styles['breadcrumbs-bar']}
        ref={breadcrumbsContainerRef}
      >
        {title && (
          <div className={styles.title}>{title}</div>
        )}

        {breadcrumbs.length ? (
          <ul>
            {breadcrumbs.map((el, index) => (
              <li key={el.path}>
                {renderBreadcrumbItem(el, (index >= breadcrumbs.length - 1))}
              </li>
            ))}
          </ul>
        ) : null}
      </div>

      <div className={styles['breadcrumbs-spacer']} />
    </>
  );
}
